import { CQRS } from '@withlocals/cqrs.js/lib/index';

import { AuthActions } from './commands';
import { authMessageHandlerFactory } from './handlers';
import { AuthQueryProcessor } from './queries';

export class AuthenticationAggregate extends CQRS<
  AuthActions,
  AuthQueryProcessor
> {
  constructor() {
    super(
      new AuthActions(),
      new AuthQueryProcessor(),
      ...authMessageHandlerFactory(),
    );
  }
}
